import React from "react";
import styled from "styled-components";
import { IconContext } from "react-icons";

const List = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;
const LinkItem = styled.a``;
const Item = styled.li`
  font-size: 24px;
`;

function SocialLinks({ list }) {
  return (
    <IconContext.Provider value={{ color: "var(--sec-color)" }}>
      <List>
        {list.map((item) => (
          <Item key={item.id}>
            <LinkItem href={item.path} target="_blank">
              {item.icon}
            </LinkItem>
          </Item>
        ))}
      </List>
    </IconContext.Provider>
  );
}

export default SocialLinks;
